import "devextreme/dist/css/dx.common.css";
import "devextreme/dist/css/dx.light.css";
import React, { Component, Fragment } from "react";
import { HashRouter, Route, Router, Switch } from "react-router-dom";
import { Provider } from "react-redux";
import { store, persistor } from "./redux/store";
// import { renderRoutes } from 'react-router-config';
import "./App.scss";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import { PersistGate } from "redux-persist/integration/react";
import ClipLoader from "react-spinners/ClipLoader";
const loading = () => (
  // <div className="animated fadeIn pt-3 text-center">Loading...</div>
  <div className="animated fadeIn pt-3 text-center center-layout-loading">
    <ClipLoader
      //size={"150px"} this also works
      color={"blue"}
      size={"70"}
      width={"100%"}
      height={10}
      loading={true}
    />
    <p>Loading......</p>
  </div>
);

// Containers
const DefaultLayout = React.lazy(() =>
  import("./components/DefaultLayout/Layout")
);

// Pages
const Login = React.lazy(() => import("./components/Account/login"));

const ChangePassword = React.lazy(() =>
  import("./components/Account/ChangePassword")
);

const ForgetPassword = React.lazy(() =>
  import("./components/Account/ForgetPassword")
);

function App() {
  return (
    <Provider store={store}>
      <ToastContainer />
      <HashRouter>
        <PersistGate persistor={persistor}>
          <React.Suspense fallback={loading()}>
            <Switch>
              <Route
                exact
                path="/login"
                name="Login Page"
                render={(props) => <Login {...props} />}
              />
              <Route
                exact
                path="/ChangePassword"
                name="ChangePassword Page"
                render={(props) => <ChangePassword {...props} />}
              />
              <Route
                exact
                path="/ForgetPassword"
                name="ForgetPassword Page"
                render={(props) => <ForgetPassword {...props} />}
              />
              <Route
                path="/"
                name="Home"
                render={(props) => <DefaultLayout {...props} />}
              />
            </Switch>
          </React.Suspense>
        </PersistGate>
      </HashRouter>
    </Provider>
  );
}

export default App;
